import React, { ReactNode } from 'react'
import {
  default as BaseSwitch,
  SwitchProps as BaseSwitchProps,
} from '@material-ui/core/Switch'
import { styled, makeStyles, Theme } from '@material-ui/core/styles'

interface SwitchProps extends Omit<BaseSwitchProps, 'onChange'> {
  labelOff?: ReactNode
  labelOn?: ReactNode
  onChange: (checked: boolean) => void
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    switchContainer: {
      '& p': {
        display: 'inline-block',
        margin: theme.spacing(0, 1),
      },
    },
  }
})
const IOSSwitch = styled(
  ({ labelOff, labelOn, onChange, ...props }: SwitchProps) => {
    const classes = useStyles()
    return (
      <div className={classes.switchContainer}>
        <p>{labelOff ?? labelOff}</p>
        <BaseSwitch
          focusVisibleClassName=".Mui-focusVisible"
          onChange={(_, checked) => onChange(checked)}
          disableRipple
          {...props}
        />
        <p>{labelOn ?? labelOn}</p>
      </div>
    )
  }
)(({ theme }) => ({
  width: 55,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: theme.spacing(0.75, 1),
    transitionDuration: '200ms',
    color: theme.palette.common.white,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      right: theme.spacing(1),
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.success.main,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    // Custom focus state
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: `6px solid ${theme.palette.common.white}`,
    },
    '&.Mui-focusVisible': {
      boxShadow: 'none',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 18,
    height: 18,
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    backgroundColor: theme.palette.grey[500],
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

export default IOSSwitch
